import * as Yup from "yup";
import {persianToEnglish} from "./helpers";

const telSchema = Yup.object().shape({
    tel: Yup.string()
        .min(11, 'شماره تلفن ۱۱ رقمی می باشد.')
        .max(11, 'شماره تلفن ۱۱ رقمی می باشد.')
        .required('  شماره تلفن را وارد کنید.').test("isNumber", "  شماره تلفن عددی می باشد", (value) => {
            if (!value) {
                return false
            }
            return !isNaN(persianToEnglish(value))
        }),
    label: Yup.string().min(3, 'عنوان قبض حداقل 3 حرف می باشد.')
        .max(20, 'عنوان قبض حداکثر 20 حرف می باشد.')
});

const mobileSchema = Yup.object().shape({
    mobile: Yup.string()
        .min(11, 'شماره تلفن همراه ۱۱ رقمی می باشد.')
        .max(11, 'شماره تلفن همراه ۱۱ رقمی می باشد.')
        .required('  شماره تلفن همراه را وارد کنید.').test("isNumber", "  شماره تلفن همراه عددی می باشد", (value) => {
            if (!value) {
                return false
            }
            return !isNaN(persianToEnglish(value))
        }),
    label: Yup.string().min(3, 'عنوان قبض حداقل 3 حرف می باشد.')
        .max(20, 'عنوان قبض حداکثر 20 حرف می باشد.')
});

const waterIdSchema = Yup.object().shape({
    water: Yup.string()
        .min(10, 'شناسه قبض  ۱۰ رقمی می باشد.')
        .max(40, 'شناسه قبض ۱۰ رقمی می باشد.')
        .required('  شناسه قبض آب را وارد کنید.').test("isNumber", "  شناسه قبض  عددی می باشد", (value) => {
            if (!value) {
                return false
            }
            return !isNaN(persianToEnglish(value))
        }),
    label: Yup.string().min(3, 'عنوان قبض حداقل 3 حرف می باشد.')
        .max(20, 'عنوان قبض حداکثر 20 حرف می باشد.')

});
const gasIdSchema = Yup.object().shape({
    gas: Yup.string()
        .min(10, 'شناسه قبض  ۱۰ رقمی می باشد.')
        .max(40, 'شناسه قبض ۱۰ رقمی می باشد.')
        .required('  شناسه قبض گاز را وارد کنید.').test("isNumber", "  شناسه قبض  عددی می باشد", (value) => {
            if (!value) {
                return false
            }
            return !isNaN(persianToEnglish(value))
        }),
    label: Yup.string().min(3, 'عنوان قبض حداقل 3 حرف می باشد.')
        .max(20, 'عنوان قبض حداکثر 20 حرف می باشد.')
});

const electricityIdSchema = Yup.object().shape({
    electricity: Yup.string()
        .min(10, 'شناسه قبض ۱۰ رقمی می باشد.')
        .max(50, 'شناسه قبض ۱۰ رقمی می باشد.')
        .required('شناسه قبض را وارد کنید.').test("isNumber", "شناسه قبض عددی می باشد", (value) => {
            if (!value) {
                return false
            }
            return !isNaN(persianToEnglish(value))
        }),
    label: Yup.string().min(3, 'عنوان قبض حداقل 3 حرف می باشد.')
        .max(20, 'عنوان قبض حداکثر 20 حرف می باشد.')
});
const loginSchema = Yup.object().shape({
    email: Yup.string().email('ایمیل معتبر نیست').max(255).required('ایمیل الزامیست.'),
    password: Yup.string().max(255).required('رمز عبور الزامیست.'),
});
const videoValidationSpeechSchema = Yup.object().shape({
    speech: Yup.string().max(256, 'متن حداکثر می‌تواند ۲۵۶کاراکتر داشته باشد .')

});
const mobileModalValidation = Yup.object().shape({
    mobile: Yup.string()
        .min(11, 'شماره تلفن ۱۱ رقمی می باشد.')
        .max(11, 'شماره تلفن ۱۱ رقمی می باشد.')
        .required('  شماره تلفن را وارد کنید.').test("isNumber", "  شماره تلفن عددی می باشد", (value) => {
            if (!value) {
                return false
            }
            return !isNaN(persianToEnglish(value))
        }).test("isMobile", " شماره تلفن همراهمعتبر نمی باشد", (value) => {
            if (!value) {
                return false
            }
            const regex = new RegExp('^(\\+98|0)?9\\d{9}$');

            return regex.test(persianToEnglish(value))
        }),

})

export {
    telSchema,
    mobileSchema,
    mobileModalValidation,
    videoValidationSpeechSchema,
    loginSchema,
    waterIdSchema,
    electricityIdSchema,
    gasIdSchema
};